import { createFileRoute } from "@tanstack/react-router"
import type { RunType } from "@/workflow/RunsPage"
import RunsPage from "@/workflow/RunsPage"

export const Route = createFileRoute("/(user)/t/$tenantSlug/runs")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      runType?: RunType
      q?: string
    },
})

function RouteComponent() {
  const { runType, q } = Route.useSearch()

  return <RunsPage runType={runType ?? "workflow"} q={q} />
}
